import { useQueryClient } from '@tanstack/react-query'

import { createInstance } from '@/helpers/api/base'
import { useAppMutation } from '@/helpers/api/mutation'
import { GET_ROUTE_DETAILS_KEY } from './useGetRouteDetails'

interface IUpdateDisruptionMitigationRequest {
    mitigation: string
}

export const useUpdateDisruptionMitigation = (id: string | number) => {
    const queryClient = useQueryClient()

    const updateMitigationMutation = useAppMutation<void, Error, IUpdateDisruptionMitigationRequest>({
        mutationFn: (data) =>
            createInstance({
                url: `/disruptions/${id}/mitigation`,
                method: 'PUT',
                data,
            }),
        alertOnError: true,
        onSuccess: async () => {
            queryClient.invalidateQueries({ queryKey: [GET_ROUTE_DETAILS_KEY], exact: false })
        },
    })

    const handleUpdateDisruptionMitigation = (mitigation: string) => {
        updateMitigationMutation.mutate({ mitigation })
    }

    return { handleUpdateDisruptionMitigation }
}
